var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "70px",
    height: "40px",
    viewBox: "0 0 70 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "V2",
    transform: "translate(-377.000000, -36.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(377.000000, 36.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28,0.00121878301 C34.627417,0.00121878301 40,5.37380179 40,12.0012188 L40,28.0012188 C40,34.6286358 34.627417,40.0012188 28,40.0012188 L0,40.0012188 L0,0.00121878301 L28,0.00121878301 Z M28,6.00121878 L6,6.00121878 L6,34.0012188 L28,34.0012188 C31.3137085,34.0012188 34,31.3149273 34,28.0012188 L34,28.0012188 L34,12.0012188 C34,8.68751028 31.3137085,6.00121878 28,6.00121878 L28,6.00121878 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,0.00121878301 L60.0007248,0.0461271408 C65.6068787,0.551696699 70,5.26342351 70,11.0012188 C70,14.7216894 68.1529491,18.0107581 65.3258048,20.0014677 C68.1529491,21.9916794 70,25.2807482 70,29.0012188 C70,34.7390141 65.6068787,39.4507409 60.0007248,39.9563104 L60,40.0012188 L36.6357736,40.0010969 C38.7823857,38.5737835 40.4431079,36.4737152 41.3169386,34.0018938 L58.5,34.0012188 C61.4634791,34.0012188 63.8795391,31.6574388 63.9956328,28.7224259 L64,28.5012188 C64,25.5377396 61.65622,23.1216796 58.7212071,23.005586 L58.5,23.0012188 L41.9997568,23.001 L41.9997568,17.001 L58.5,17.0012188 C61.4634791,17.0012188 63.8795391,14.6574388 63.9956328,11.7224259 L64,11.5012188 C64,8.53773964 61.65622,6.12167965 58.7212071,6.00558599 L58.5,6.00121878 L41.3172055,6.00129885 C40.4431725,3.52837595 38.7815641,1.42748416 36.6337568,2.0539126e-14 L60,0.00121878301 Z",
    id: "Combined-Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.7b5196c31c53228b040c5c36a66525a1.svg";
export { ForwardRef as ReactComponent };